enum StaplePageActions {
  Added = 'added',
  Removed = 'removed'
};

export default StaplePageActions;
